import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from 'src/app/service/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivateChild {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    // isAuthenticated()는 형식이 깨진 토큰에 jwtHelper가 throw한다. 가드에서 새어 나가면
    // 라우터가 전환을 중단해 빈 화면이 되므로, 판정 불가는 미인증으로 본다.
    let isAuthenticated = false;
    try {
      isAuthenticated = this.authService.isAuthenticated();
    } catch {
      isAuthenticated = false;
    }

    //TODO(#2250) 유효하지 않을 경우 Refresh Token으로 Access Token 재발급 요청
    if (isAuthenticated) {
      return true;
    }
    return this.router.createUrlTree(['/tabs/login'], {
      queryParams: { returnUrl: state.url },
    });
  }
}
